const Mission = () => {
  return (
    <article>
      <h2 className="text-[#408099] font-bold text-md md:text-lg lg:text-2xl mb-2 md:mb-4">
        الرسالة
      </h2>
      <p>
        تقديم برامج اجتماعية وتنموية تلبي احتياجات المجتمع وفق المعايير العالمية
        بكفاءات وشراكات متميزة تسهم في تحقيق التكافل الاجتماعي والاستقرار
        المجتمعي
      </p>
    </article>
  );
};
export default Mission;
